import { defineComponent as d, computed as o, openBlock as c, createElementBlock as a, createElementVNode as e, toDisplayString as n, createCommentVNode as h, normalizeStyle as f } from "vue";
const _ = ["viewBox"], v = /* @__PURE__ */ e("mask", { id: "5caef9a5-1edc-40be-bb8a-5de3efac6dd2" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#5caef9a5-1edc-40be-bb8a-5de3efac6dd2)" }, u = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m0 256 255.2-39.6L512 256v256H0z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#0052b4",
  d: "M0 0h512v256H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M189.2 178a33.4 33.4 0 0 0-55.6-24.8v-19.6h11.1v-22.3h-11.1v-11.1h-22.3v11.1h-11.1v22.3h11.1v19.6A33.4 33.4 0 0 0 66.8 203v19.6H178V203c6.8-6.1 11.1-15 11.1-25z"
}, null, -1), x = { fill: "none" }, b = ["r"], z = /* @__PURE__ */ d({
  __name: "li",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const t = i, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (w, y) => (c(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      v,
      e("g", m, [
        t.flagName ? (c(), a("title", u, n(t.flagName), 1)) : h("", !0),
        k,
        p,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, _));
  }
});
export {
  z as default
};
//# sourceMappingURL=li-d32ef730.js.map
